<div class="spinner-wrapper">
    <div class="loading">
        <img class="loading-image" src="assets/images/loading.jpg" />
    </div>
</div>
